import { call, put, take, select } from "redux-saga/effects";
import { push } from "connected-react-router";

import { MODAL_TYPES } from "../constants/modals";
import * as actions from "../constants/actions";
import * as actionTypes from "../constants/actionTypes";
import firebase from "../services/firebase";
import api from "../services/api";
import { getUserId } from "../selectors";

export function* fetchUser({ payload }) {
  const { id } = payload;
  const { error, user } = yield call(firebase.user.fetch, id);

  if (error) {
    // TODO: handle error
  } else {
    yield put(actions.setUser({ user }));
  }
}

export function* fetchUserAdminResources({ payload }) {
  const { token } = payload;
  const { error, resources } = yield call(api.admin.fetchResources, token);

  if (error) {
    yield put(actions.fetchUserAdminResourcesFailed({ error }));
  } else {
    yield put(actions.fetchUserAdminResourcesSucceeded({ resources }));
  }
}

export function* updateUserHasVisited() {
  const { error } = yield call(firebase.user.updateUserHasVisited);

  if (error) {
    // TODO: handle error
  } else {
    yield put(actions.closeModal());
  }
}

export function* updateUser({ payload }) {
  const { values, resolve, reject } = payload;
  const { error, user } = yield call(firebase.user.update, values);

  if (error) {
    if (error === "auth/requires-recent-login") {
      resolve();
      yield put(actions.openModal({ modalType: MODAL_TYPES.SECURITY_SIGNIN }));
    } else {
      reject(error);
    }
  } else {
    resolve();
    yield put(actions.setUser({ user }));
  }
}

export function* deleteUser({ payload }) {
  yield put(
    actions.openModal({
      modalType: MODAL_TYPES.DELETE_USER_CONFIRMATION
    })
  );

  const { type } = yield take([
    actionTypes.MODAL_CONFIRMED,
    actionTypes.MODAL_CLOSE
  ]);

  if (type !== actionTypes.MODAL_CONFIRMED) {
    return;
  }

  const id = yield select(getUserId);
  const { error } = yield call(firebase.user.destroy, id);

  yield put(actions.closeModal());

  if (error) {
    // handle security signin
    yield put(actions.openModal({ modalType: MODAL_TYPES.SECURITY_SIGNIN }));
  } else {
    yield put(push("/"));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/user.js